import { Star, BookOpen, BarChart, Clock } from 'lucide-react';
import moment from 'moment';

function EventDetails({close,setRefresh,event}) {

    // const discountedPrice = Number(event?.price) * (1 - Number(event?.discount_percentage) / 100);

    return (
        <div className=" py-4 px-2 sm:px-1 lg:px-2">
            <div className="mx-auto bg-white rounded-2xl shadow-lg overflow-hidden">
                {/* Course Image */}
                <div className="relative h-72 w-full">
                    <img
                        src={`${process.env.REACT_APP_IMAGE_URI}${event?.image}`}
                        alt={event?.title}
                        className="w-full h-full object-cover"
                    />
                    <div className={`absolute top-4 right-4 ${event?.status==="Active"?"bg-green-500":"bg-red-500"} text-white px-3 py-1 rounded-full text-sm font-medium`}>
                        {event?.status}
                    </div>
                </div>

                {/* Course Content */}
                <div className="p-8">
                    {/* Header Section */}
                    <div className="mb-6">
                        <div className="flex items-center justify-between mb-2">
                            <h1 className="text-3xl font-bold text-gray-900">{event?.title}</h1>
                            <div className="flex items-center gap-1">
                                {/* <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" /> */}
                                <span className="text-lg font-semibold">{event?.language}</span>
                            </div>
                        </div>
                        <div className="flex flex-col gap-4 text-sm text-gray-600">
                            {/* <span>Course ID: <span className='font-semibold'>{event?.class_id}</span> </span> */}
                            <span>Internal ID: <span className='font-semibold'>{event?._id}</span></span>
                            <span>Date: <span className='font-semibold'>{event?.date}</span></span>
                            <span>Time: <span className='font-semibold'>{event?.time}</span></span>
                            <span>Button Text: <span className='font-semibold'>{event?.btnText}</span></span>
                            <span>Show Button: <span className='font-semibold break-words'>{event?.btnShow}</span></span>
                            <span>Page Link: <span className='font-semibold break-words'>{event?.pageUrl}</span></span>
                            <span>Created At: <span className='font-semibold break-words'>{moment(event?.createdAt).format('Do-MMM-YY hh:mm a')}</span></span>
                        </div>
                    </div>

                    {/* Stats Grid */}
                    <div className="grid grid-cols-2 md:grid-cols-2 gap-4 mb-8">
                        {/* <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex items-center gap-2 text-gray-600 mb-1">
                                <BookOpen className="w-4 h-4" />
                                <span>Course</span>
                            </div>
                            <p className="text-xl font-bold">{event?.course}</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex items-center gap-2 text-gray-600 mb-1">
                                <BarChart className="w-4 h-4" />
                                <span>Delivery Method</span>
                            </div>
                            <p className="font-bold">{event?.deliveryMethod}</p>
                        </div> */}
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex items-center gap-2 text-gray-600 mb-1">
                                <Clock className="w-4 h-4" />
                                <span>Priority</span>
                            </div>
                            <p className="text-xl font-bold">{event?.precedence}</p>
                        </div>
                        <div className="bg-gray-50 p-4 rounded-lg">
                            <div className="flex flex-col">
                                <span className="text-gray-600">Price</span>
                                <div className="flex items-center gap-2 flex-wrap">
                                    <span className="text-xl font-bold">{event?.price}</span>
                                    <div>
                                        <span className="text-sm text-gray-500 line-through mr-2">{event?.price}</span>
                                        {/* <span className="text-green-500 text-sm">-{event?.discount_percentage}%</span> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Description */}
                    {/* <div className="mb-8">
                        <h2 className="text-xl font-semibold mb-4">Class Description</h2>
                        <p className="text-gray-600 leading-relaxed">
                            {event?.description}
                        </p>
                    </div> */}

                    {/* CTA Button */}
                    {/* <button className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors">
                        Enroll Now
                    </button> */}
                </div>
            </div>
        </div>
    );
}

export default EventDetails;